import { render, staticRenderFns } from "./ReferralButton.vue?vue&type=template&id=10745314&scoped=true&"
import script from "./ReferralButton.vue?vue&type=script&lang=ts&"
export * from "./ReferralButton.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralButton.vue?vue&type=style&index=0&id=10745314&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10745314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('10745314', component.options)
    } else {
      api.reload('10745314', component.options)
    }
    module.hot.accept("./ReferralButton.vue?vue&type=template&id=10745314&scoped=true&", function () {
      api.rerender('10745314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/referral/components/ReferralButton.vue"
export default component.exports